import { Controller } from "@hotwired/stimulus"

// Guest List tab: the stat pills double as filters.
//
// The pills live outside the guests-list Turbo Frame they reload, and Turbo
// Streams (RSVP changes, adds, deletes) re-render them without knowing the
// current filter, so this keeps the pills' active state and the search form's
// hidden filter field in step with whichever pill was last clicked. A click
// submits the search form (filter + whatever is typed in the search box) when
// there is one; the pill's own href is the no-JS / no-guests fallback.
export default class extends Controller {
  static targets = ["pill", "input", "form", "search"]

  connect() {
    // The server renders the initial state (hidden field + aria-pressed)
    this.selected = this.hasInputTarget ? this.inputTarget.value : this.pressedPillKey()
  }

  select(event) {
    this.apply(event.params.key || "")
    this.submit(event)
  }

  // "Show all guests" from the no-matches state: drop the filter and the search
  clear(event) {
    if (this.hasSearchTarget) this.searchTarget.value = ""
    this.apply("")
    this.submit(event)
  }

  // Re-rendered pills (e.g. after an RSVP change) arrive without the filter
  pillTargetConnected(pill) {
    if (this.selected !== undefined) this.paint(pill)
  }

  apply(key) {
    this.selected = key
    if (this.hasInputTarget) this.inputTarget.value = key
    this.pillTargets.forEach(pill => this.paint(pill))
  }

  submit(event) {
    if (!this.hasFormTarget) return // no guests yet: the link navigates on its own
    event.preventDefault()
    this.formTarget.requestSubmit()
  }

  paint(pill) {
    const active = (pill.dataset.guestFilterKeyParam || "") === this.selected
    const idle = pill.dataset.idleClass.split(" ")
    const on = pill.dataset.activeClass.split(" ")
    pill.classList.remove(...idle, ...on)
    pill.classList.add(...(active ? on : idle))
    pill.setAttribute("aria-pressed", active)
  }

  pressedPillKey() {
    const pressed = this.pillTargets.find(pill => pill.getAttribute("aria-pressed") === "true")
    return pressed?.dataset.guestFilterKeyParam || ""
  }
}
